var map = {
	"./BOOST.svg": 2409,
	"./GRAB.svg": 2410,
	"./MBB.svg": 2411,
	"./TNG.svg": 2412,
	"./direpay.svg": 2413,
	"./doitnow.svg": 2414,
	"./duitnow.svg": 2415,
	"./fpay.svg": 2416,
	"./fpay2.svg": 2417,
	"./fpx.svg": 2418,
	"./online_banking.svg": 2419,
	"./rapidpays.svg": 2420,
	"./secret_pay.svg": 2421,
	"./secret_pay_offline.svg": 2422,
	"./secret_pay_pro.svg": 2423,
	"./secret_pay_pro_b.svg": 2424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 217;